import React, { useCallback, useContext } from "react";
import { getKds, updateKds, updateKdsMappings } from "apis";
import { useApi, useMount } from "hooks";
import { useParams, useLocation } from "react-router-dom";
import { mapObject } from "services";
import { kdsDetailResponse, kdsRequest } from "mappers";
import { VenueContext } from "contexts";
import KdsForm from "../kds-form/kds-form.module";

const EditKds = () => {
  const { id } = useParams();
  const { state: routeState } = useLocation();
  const { venue } = useContext(VenueContext);
  const { venueId } = venue;

  const { request: getRequest, mappedData: fetchedData, loading } = useApi({
    api: getKds,
    mapper: kdsDetailResponse,
    handleOwnError: true,
  });
  const { request: updateRequest, loading: updating } = useApi({
    api: updateKds,
    handleOwnError: { badrequest: true },
  });
  const { request: mappingRequest } = useApi({
    api: updateKdsMappings,
    handleOwnError: { badrequest: true },
  });

  useMount(() => {
    getRequest({ kdsId: id, venueId });
  });

  // Use data from list navigation state immediately; overlay with full API response once loaded
  const initialData = (fetchedData && Object.keys(fetchedData).length > 0)
    ? fetchedData
    : routeState?.kdsData;

  const submit = useCallback(
    async (params) => {
      const payload = mapObject(params, kdsRequest);
      await updateRequest({ kdsId: id, ...payload });
      await mappingRequest({
        kdsId: id,
        venueId: params.venueId,
        outletId: params.outletId,
        category_ids: params.category_ids || [],
        product_ids: params.product_ids || [],
        sku_ids: params.sku_ids || [],
      });
      return { message: `${params.name} updated` };
    },
    [id, mappingRequest, updateRequest]
  );

  return (
    <KdsForm
      title={"Edit KDS"}
      loading={loading && !routeState?.kdsData}
      initialState={initialData}
      submitting={updating}
      submit={submit}
    />
  );
};

export default EditKds;
